export default __webpack_public_path__ + "static/Tapetsering7-285d60ae5d666c0706c172e671378e83.jpg";